import { render } from "./main-page.vue?vue&type=template&id=3064f534&scoped=true&ts=true"
import script from "./main-page.vue?vue&type=script&lang=ts"
export * from "./main-page.vue?vue&type=script&lang=ts"

import "./main-page.scss?vue&type=style&index=0&id=3064f534&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3064f534"]])

export default __exports__